import { jsx as _jsx } from "react/jsx-runtime";
import { HeartFillIcon, HeartIcon } from '@yonderland/andes-icons';
import { IconButton, useBreakpoints, useIsClient } from '@yonderland/andes-react';
import { useState } from 'react';
import { showMobileHeader } from '../../../util/HtmlElementUtil';
export const AddToWishlistButton = ({ isProductInWishList, onToggle, wishListProduct, buttonProps, }) => {
    const [animate, setAnimate] = useState(false);
    const { isXs, isSm } = useBreakpoints();
    const isDesktop = !(isXs || isSm);
    const isClient = useIsClient();
    const toggleWishListProduct = () => {
        onToggle(wishListProduct);
        setAnimate(!isProductInWishList);
        !isDesktop && showMobileHeader();
    };
    return (_jsx(IconButton, Object.assign({ testId: "add_to_wishlist", theme: "branded", size: "md", inverse: true, icon: {
            source: isClient && isProductInWishList ? HeartFillIcon : HeartIcon,
            size: 'sm',
            animation: animate ? 'pulse' : undefined,
        }, onClick: toggleWishListProduct }, buttonProps)));
};
